// client/src/services/notesApi.js
// API wrapper for notes (server/routes/noteRoutes.js). A note links to any
// number of events / event items / event actions / posts / campaigns, or none.

import { postJson, putJson } from './http';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';
const base = (tenantId) => `/api/tenants/${Number(tenantId)}/notes`;

// http.js getJson/delJson drop the response body on failure; notes surface the
// server's message (e.g. "Notes need a database migration…") so read it here.
async function send(method, url) {
  const res = await fetch(`${BASE_URL}${url}`, { method, credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

/** All notes, or only those linked to one record ({ refType, refId }); refType 'none' = unassociated. */
export async function listNotes(tenantId, { refType, refId } = {}) {
  const qs = new URLSearchParams();
  if (refType) qs.set('refType', refType);
  if (refId) qs.set('refId', String(refId));
  const q = qs.toString();
  return send('GET', `${base(tenantId)}${q ? `?${q}` : ''}`);
}

/** Open records a note can be associated with, grouped by type. */
export async function listNoteTargets(tenantId) {
  return send('GET', `${base(tenantId)}/targets`);
}

export async function getActionIdForItem(tenantId, itemId) {
  return send('GET', `${base(tenantId)}/action-for-item/${Number(itemId)}`);
}

export async function createNote(tenantId, payload) {
  return postJson(base(tenantId), payload);
}

export async function updateNote(tenantId, id, payload) {
  return putJson(`${base(tenantId)}/${Number(id)}`, payload);
}

export async function deleteNote(tenantId, id) {
  return send('DELETE', `${base(tenantId)}/${Number(id)}`);
}
